import React, { useState, useCallback, useEffect } from 'react';
import { Button, Form, Input, message, Spin } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useForm } from 'antd/lib/form/Form';

import { loginUser, socialLoginUser } from '../../service/auth/AuthService';
import { useDispatch, useSelector } from 'react-redux';
import { userAction } from '../../reducer/userReducer';
import { useNavigate } from 'react-router-dom';
import { setAccessToken, getAccessToken } from '../../helper/tokenHelper';
import { Format_Email } from '../../constant/auth.constant';
import { errorAuth } from '../../enum/auth.error';
import { firebaseConfig } from '../../config/config';

const REDIRECT_URI = window.location.href;

import { getAuth, signInWithPopup } from 'firebase/auth';
import firebase from 'firebase/app';
import 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';

// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
// const analytics = getAnalytics(app);

import './Authenticate.scss';

export default function Authenticate() {
	// const rememberMe = getRememberMe() === 'true';
	const dispatch = useDispatch();
	const [isSpin, setIsSpin] = useState(false);
	const navigate = useNavigate();
	const [formLogin] = useForm();
	// const infoLocal = getUserAndPassword();

	// useEffect(() => {
	// 	if (rememberMe) {
	// 		formLogin.setFieldsValue({
	// 			email: infoLocal.email,
	// 			password: infoLocal.password,
	// 			rememberMe,
	// 		});
	// 	} else {
	// 		deleteRememberMe();
	// 		deleteUserAndPasswordLocal();
	// 	}
	// }, []);

	const onFinish = (values: any) => {
		const params = {
			email: values.email,
			password: values.password,
		};
		setIsSpin(true);
		loginUser(params)
			.then((res: any) => {
				message.success('Bạn đã đăng nhập thành công');
				localStorage.clear;
				console.log(getAccessToken());
				setAccessToken(res.data.access_token);
				console.log(getAccessToken());
				setIsSpin(false);
				window.location.replace('/home');
			})
			.catch((err: any) => {
				console.log(err);
				// message.error(err.response.data.detail);
				setIsSpin(false);
			});
	};

	const onFinishFailed = (errorInfo: any) => {
		console.log('Failed:', errorInfo);
	};

	return (
		<Spin size="small" spinning={isSpin} delay={1000}>
			<div className="w-full h-[100vh] bg_auth ">
				<div className="h-full flex items-center bg ">
					<div className="item_auth w-1/2 sm:w-full md:w-[90%] lg:w-[80%]  sm:h-full flex items-center justify-center m-auto h-[90%] rounded-lg overflow-hidden box shadow-lg shadow-gray-500  ">
						<div className="bg_left w-1/2 h-full md:hidden"></div>
						<div className="w-1/2 h-full md:w-full bg_right">
							<Form
								form={formLogin}
								name="basic"
								labelCol={{ span: 32 }}
								wrapperCol={{ span: 32 }}
								initialValues={{ remember: true }}
								onFinish={onFinish}
								onFinishFailed={onFinishFailed}
								autoComplete="off"
								layout="vertical"
								size="large"
								className="   lg:px-8 md:px-5 sm:px-2 w-full h-full bg_right rounded my-auto flex items-center justify-center lg:flex lg:justify-center"
							>
								<div className="py-auto px-4 ">
									<h1 className="mb-[2rem] text-4xl font-sans text-center text-red-500 md:text-3xl">
										Happy Lunch
									</h1>
									<p className="text-red-400 text-center sm:text-xs text-base mb-0 italic ">
										Welcome to Happy Luch with Shapee Cloud.
										<br /> Have a nice day!
									</p>
									<Form.Item
										className="rounded-md item-form-input "
										label={
											<label
												style={{
													fontSize: '14px',
													fontWeight: '500',
												}}
											>
												Email / Username
											</label>
										}
										name="email"
										rules={[
											{
												required: true
											},
										]}
									>
										<Input prefix={<UserOutlined className="mr-2" />} placeholder="Email" />
									</Form.Item>

									<Form.Item
										className="rounded-md item-form-input p-0 "
										name="password"
										label={
											<label
												style={{
													fontSize: '14px',
													fontWeight: '500',
												}}
											>
												Password
											</label>
										}
										rules={[
											{
												validator(rule, val) {
													if (val === undefined || val === null || val === '') {
														return Promise.reject(new Error(errorAuth.PASSWORD_NONE));
													} else if (val.length < 6) {
														return Promise.reject(new Error(errorAuth.PASSWORD_LENGTH));
													} else {
														return Promise.resolve();
													}
												},
											},
										]}
									>
										<Input.Password
											prefix={<LockOutlined className="mr-2" />}
											placeholder="Password"
										/>
									</Form.Item>

									<Form.Item
										wrapperCol={{ offset: 40, span: 32 }}
										className="w-full rounded-lg flex justify-center "
									>
										<Button
											type="primary"
											danger
											htmlType="submit"
											className="w-[10rem]  rounded-lg mt-10 "
										>
											<p className="m-auto sm:text-sm">Login</p>
										</Button>
									</Form.Item>
								</div>
							</Form>
						</div>
					</div>
				</div>
			</div>
		</Spin>
	);
}
